export default __webpack_public_path__ + "static/media/dog-blue.9a61c85a.svg";